// components/TeamAndPartners.js
import React from "react";
import "./TeamAndPartners.css"; // import the stylesheet
import FluencyCoachCollaborator from "./FluencyCoachCollaborator.png";
import AIandAudioEngineer from "./AIandAudioEngineer.png";
import PartnerInstitution from "./PartnerInstitution.png";

const team = [
  {
    name: "To Be Announced",
    role: "Fluency Coach / Collaborator",
    description:
      "Future ESL specialists who will help learners gain confidence through guided speaking practice and one-to-one feedback.",
    img: FluencyCoachCollaborator,
  },
  {
    name: "To Be Announced",
    role: "AI & Audio Engineer",
    description:
      "Developers helping to refine speech recognition, phoneme analysis, and avatar-driven lip-syncing for the iSpeakWell platform.",
    img: AIandAudioEngineer,
  },
  {
    name: "To Be Announced",
    role: "Partner Institution / Sponsor",
    description:
      "Schools, nonprofits, and investors joining to expand measurable fluency training and pilot programs across Alberta and beyond.",
    img: PartnerInstitution,
  },
];

export default function TeamAndPartners() {
  return (
    <section className="team-section">
      <div className="team-container">
        <h2 className="team-title">Team & Partners</h2>
        <p className="team-intro">
          The iSpeakWell Project is built on collaboration. As we expand, we’re seeking
          creative technologists, educators, and organizations who share our mission to
          make English fluency accessible, measurable, and empowering for everyone.
        </p>

        <div className="team-grid">
          {team.map((member, i) => (
            <div key={i} className="team-card">
              <div className="team-image-wrap">
                <img src={member.img} alt={member.name} className="team-image" />
              </div>
              <div className="team-info">
                <h3 className="team-name">{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-description">{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
